"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var IntlPolyfill = require("intl");
var areIntlLocalesSupported = require("intl-locales-supported");
var React = require("react");
var intlEN = require("react-intl/locale-data/en");
var intlID = require("react-intl/locale-data/id");
var react_intl_1 = require("react-intl");
require("intl/locale-data/jsonp/en");
require("intl/locale-data/jsonp/id");
exports.LOCALE_EN = 'EN';
exports.LOCALE_ID = 'ID';
if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!areIntlLocalesSupported([exports.LOCALE_EN, exports.LOCALE_ID])) {
        // `Intl` exists, but it doesn't have the data we need, so load the
        // polyfill and replace the constructors with need with the polyfill's.
        Intl.NumberFormat = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
}
else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = IntlPolyfill;
}
var LocaleProvider = /** @class */ (function (_super) {
    tslib_1.__extends(LocaleProvider, _super);
    function LocaleProvider(props) {
        var _this = _super.call(this, props) || this;
        react_intl_1.addLocaleData(intlEN);
        react_intl_1.addLocaleData(intlID);
        return _this;
    }
    LocaleProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.locale, locale = _b === void 0 ? exports.LOCALE_ID : _b, messages = _a.messages;
        return (React.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages[locale] }, children));
    };
    return LocaleProvider;
}(React.Component));
exports.LocaleProvider = LocaleProvider;
//# sourceMappingURL=LocaleProvider.js.map